import { CheckCircle2, XCircle, AlertTriangle, Info } from "lucide-react";

const ICONS = {
  success: [CheckCircle2, "text-emerald-400"],
  error: [XCircle, "text-red-500"],
  warning: [AlertTriangle, "text-amber-400"],
  info: [Info, "text-sky-400"],
};

// Shared notification card (DTC-dialog style, slightly larger). Used by toasts and floating dialogs.
export const NotifyCard = ({ type = "info", title, message, children, actions, testid = "notify-card" }) => {
  const [Icon, color] = ICONS[type] || ICONS.info;
  return (
    <div data-testid={testid} className="w-[min(92vw,480px)] rounded-xl border border-amber-500/40 bg-[#0c1017]/95 backdrop-blur-md shadow-2xl shadow-black/60 p-5 text-left animate-in fade-in zoom-in-95 duration-200">
      <div className="flex items-start gap-3">
        <Icon className={`${color} shrink-0 mt-0.5`} size={24} />
        <div className="flex-1 min-w-0">
          {title && <div data-testid={`${testid}-title`} className={`text-[16px] font-extrabold tracking-wide ${color}`}>{title}</div>}
          {message && <div data-testid={`${testid}-message`} className={`text-[15px] leading-relaxed text-slate-100 whitespace-pre-line break-words ${title ? "mt-1" : ""}`}>{message}</div>}
          {children}
        </div>
      </div>
      {actions && <div className="flex flex-wrap justify-end gap-2 mt-4">{actions}</div>}
    </div>
  );
};

export const notifyBtn = {
  ok: "px-5 py-2 rounded-lg text-[14px] font-bold text-white bg-amber-600 hover:bg-amber-500 transition-colors",
  danger: "px-5 py-2 rounded-lg text-[14px] font-bold text-white bg-red-600 hover:bg-red-500 transition-colors",
  ghost: "px-5 py-2 rounded-lg text-[14px] font-semibold text-slate-200 bg-slate-700/60 hover:bg-slate-700 transition-colors",
};

export const NotifyOverlay = ({ children, onClose, testid }) => (
  <div data-testid={testid} onClick={onClose} className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 p-4">
    <div onClick={(e) => e.stopPropagation()}>{children}</div>
  </div>
);
